(() => {
  'use strict';

  const MONEY = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 2 });
  const RECENT_KEY = 'yaax_recent_products_v1';
  const RECENT_TTL = 30 * 24 * 60 * 60 * 1000;

  const MAGNESIUM_COMPARE = [
    { handle: 'citrato-de-magnesio-90-capsulas-500-mg-yaax-vida-100-puro', label: '90 cápsulas', units: 90, unitLabel: 'cápsula' },
    { handle: 'citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro', label: '500 g polvo', grams: 500, unitLabel: '100 g' },
    { handle: 'copia-de-citrato-de-magnesio-500-grs-polvo-yaax-vida-100-puro', label: '1 kg polvo', grams: 1000, unitLabel: '100 g' }
  ];

  function currentHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function moneyFromCents(cents) {
    return MONEY.format((Number(cents) || 0) / 100);
  }

  function parseMoneyText(text) {
    if (!text) return 0;
    const cleaned = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    const value = Number.parseFloat(cleaned);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }

  async function fetchProduct(handle) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`No se pudo cargar ${handle}`);
    return response.json();
  }

  // 4) Multi-add for complementary products. It enhances Shopify Search & Discovery recommendations
  // without changing the underlying recommendations or discount logic.
  function enhanceComplementaryProducts(root = document) {
    root.querySelectorAll('product-recommendations.complementary-products').forEach((container) => {
      if (container.dataset.yaaxMultiAdd === '1') return;
      const items = Array.from(container.querySelectorAll('.complementary-products__container li'));
      if (!items.length) return;

      const eligible = [];
      items.forEach((item) => {
        if (item.querySelector('.yaax-fbt-check')) return;
        const variantInput = item.querySelector('input[name="id"]');
        const titleEl = item.querySelector('.card__heading a, .card__heading, a.full-unstyled-link');
        const priceEl = item.querySelector('.price-item--sale, .price__sale .price-item--last, .price-item--regular');
        const variantId = variantInput && variantInput.value;
        if (!variantId || !titleEl) return;

        const title = titleEl.textContent.trim();
        const priceCents = parseMoneyText(priceEl && priceEl.textContent);
        const selector = document.createElement('label');
        selector.className = 'yaax-fbt-check';
        selector.innerHTML = `<input type="checkbox" data-variant-id="${variantId}" data-price-cents="${priceCents}"><span>Seleccionar</span>`;
        item.insertAdjacentElement('afterbegin', selector);
        eligible.push(selector.querySelector('input'));
      });

      if (!eligible.length) return;
      container.dataset.yaaxMultiAdd = '1';

      const controls = document.createElement('div');
      controls.className = 'yaax-fbt-controls';
      controls.innerHTML = `
        <div class="yaax-fbt-copy">
          <strong>Completa tu pedido</strong>
          <span>Selecciona varios complementos y agrégalos juntos. El descuento Mix & Match se aplicará automáticamente cuando se cumplan sus condiciones.</span>
        </div>
        <div class="yaax-fbt-summary" aria-live="polite"><span class="yaax-fbt-count">0 seleccionados</span><strong class="yaax-fbt-total">${moneyFromCents(0)}</strong></div>
        <button type="button" class="button button--full-width yaax-fbt-add" disabled>Agregar seleccionados</button>
        <small>Los productos con opciones adicionales conservan su botón “Elegir opciones” y no se agregan desde este selector.</small>`;

      const host = container.querySelector('.complementary-products__container');
      host.appendChild(controls);

      const countEl = controls.querySelector('.yaax-fbt-count');
      const totalEl = controls.querySelector('.yaax-fbt-total');
      const addBtn = controls.querySelector('.yaax-fbt-add');

      const update = () => {
        const checked = eligible.filter((input) => input.checked);
        const total = checked.reduce((sum, input) => sum + Number(input.dataset.priceCents || 0), 0);
        countEl.textContent = `${checked.length} ${checked.length === 1 ? 'seleccionado' : 'seleccionados'}`;
        totalEl.textContent = moneyFromCents(total);
        addBtn.disabled = checked.length === 0;
      };
      eligible.forEach((input) => input.addEventListener('change', update));

      addBtn.addEventListener('click', async () => {
        const checked = eligible.filter((input) => input.checked);
        if (!checked.length) return;
        addBtn.disabled = true;
        const original = addBtn.textContent;
        addBtn.textContent = 'Agregando…';
        try {
          const body = {
            items: checked.map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 })),
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          };
          const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'No fue posible agregar los productos.');

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
          checked.forEach((input) => { input.checked = false; });
          update();
          addBtn.textContent = 'Agregados ✓';
          setTimeout(() => { addBtn.textContent = original; update(); }, 1800);
        } catch (error) {
          console.error('[Yaax multi-add]', error);
          addBtn.textContent = 'Intenta de nuevo';
          addBtn.disabled = false;
        }
      });
    });
  }

  // 5) Compact comparator for the 3 priority magnesium presentations.
  async function renderMagnesiumComparator() {
    if (!document.body.classList.contains('template-product') || document.querySelector('.yaax-compare-presentations')) return;
    const handle = currentHandle();
    if (!MAGNESIUM_COMPARE.some((item) => item.handle === handle)) return;

    const anchor = document.querySelector('.yaax-magnesium-campaign-format, .yaax-presentations');
    if (!anchor) return;

    const details = document.createElement('details');
    details.className = 'yaax-compare-presentations';
    details.innerHTML = '<summary><span>Comparar presentaciones</span><span aria-hidden="true">+</span></summary><div class="yaax-compare-loading">Cargando comparación…</div>';
    anchor.insertAdjacentElement('afterend', details);

    try {
      const products = await Promise.all(MAGNESIUM_COMPARE.map(async (config) => ({ config, product: await fetchProduct(config.handle) })));
      const powderUnitCosts = products
        .filter(({ config }) => config.grams)
        .map(({ config, product }) => ({ handle: config.handle, value: product.price / (config.grams / 100) }));
      const bestPowder = powderUnitCosts.length ? powderUnitCosts.reduce((a, b) => a.value <= b.value ? a : b).handle : '';

      const rows = products.map(({ config, product }) => {
        let unitText = '';
        if (config.units) unitText = `${moneyFromCents(product.price / config.units)} / cápsula`;
        if (config.grams) unitText = `${moneyFromCents(product.price / (config.grams / 100))} / 100 g`;
        const current = config.handle === handle;
        const best = config.handle === bestPowder;
        return `<div class="yaax-compare-row${current ? ' is-current' : ''}">
          <div><strong>${config.label}</strong>${current ? '<span class="yaax-compare-current">Actual</span>' : ''}${best ? '<span class="yaax-compare-best">Mejor costo / 100 g</span>' : ''}</div>
          <div><strong>${moneyFromCents(product.price)}</strong><span>${unitText}</span></div>
          <div>${current ? '<span class="yaax-compare-selected">Seleccionado</span>' : `<a href="/products/${config.handle}" class="button button--secondary">Ver</a>`}</div>
        </div>`;
      }).join('');

      details.querySelector('.yaax-compare-loading').outerHTML = `<div class="yaax-compare-body"><p>Compara precio y contenido sin hacer cálculos. Cápsulas y polvo son formatos distintos; el costo unitario se muestra sólo como referencia de cada presentación.</p>${rows}</div>`;
    } catch (error) {
      console.error('[Yaax comparator]', error);
      details.remove();
    }
  }

  // 8) Recently viewed products using first-party browser storage only.
  function readRecent() {
    try {
      const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      const cutoff = Date.now() - RECENT_TTL;
      return Array.isArray(list) ? list.filter((item) => item && item.handle && item.seenAt >= cutoff) : [];
    } catch (_) {
      return [];
    }
  }

  function saveRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8))); } catch (_) {}
  }

  async function captureCurrentProduct() {
    if (!document.body.classList.contains('template-product')) return;
    const handle = currentHandle();
    if (!handle) return;
    try {
      const product = await fetchProduct(handle);
      const list = readRecent().filter((item) => item.handle !== handle);
      list.unshift({
        handle,
        title: product.title,
        url: product.url || `/products/${handle}`,
        image: product.featured_image || (product.images && product.images[0]) || '',
        price: product.price,
        seenAt: Date.now()
      });
      saveRecent(list);
    } catch (error) {
      console.error('[Yaax recently viewed capture]', error);
    }
  }

  function renderRecentlyViewed() {
    if (!document.body.classList.contains('template-product') || document.body.classList.contains('template-suffix-campaign')) return;
    if (document.querySelector('.yaax-recently-viewed')) return;
    const current = currentHandle();
    const items = readRecent().filter((item) => item.handle !== current).slice(0, 4);
    if (!items.length) return;

    const section = document.createElement('section');
    section.className = 'page-width yaax-recently-viewed';
    section.innerHTML = `<div class="yaax-recently-viewed__head"><h2>Vistos recientemente</h2><p>Retoma productos que consultaste durante tu visita.</p></div><div class="yaax-recent-grid">${items.map((item) => `
      <article class="yaax-recent-card">
        <a href="${item.url}" class="yaax-recent-image">${item.image ? `<img src="${item.image}" alt="${String(item.title).replace(/"/g, '&quot;')}" loading="lazy">` : ''}</a>
        <div class="yaax-recent-info"><a href="${item.url}" class="yaax-recent-title">${item.title}</a><strong>${moneyFromCents(item.price)}</strong><a href="${item.url}" class="button button--secondary">Ver producto</a></div>
      </article>`).join('')}</div>`;

    const related = document.querySelector('.related-products');
    const host = related && related.closest('.shopify-section');
    if (host) host.insertAdjacentElement('afterend', section);
    else document.querySelector('#MainContent')?.appendChild(section);
  }

  function boot() {
    if (!document.body.classList.contains('template-product')) return;
    enhanceComplementaryProducts();
    renderMagnesiumComparator();
    renderRecentlyViewed();
    captureCurrentProduct();

    document.querySelectorAll('product-recommendations.complementary-products').forEach((container) => {
      const observer = new MutationObserver(() => enhanceComplementaryProducts(container.parentElement || document));
      observer.observe(container, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 12000);
    });

    // The existing presentation selector is injected after DOMContentLoaded; retry briefly.
    let tries = 0;
    const comparatorTimer = setInterval(() => {
      tries += 1;
      renderMagnesiumComparator();
      if (document.querySelector('.yaax-compare-presentations') || tries >= 12) clearInterval(comparatorTimer);
    }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
